// Import independent property types
import './code';
import './file';
import './repeater';
import './text';
import './textarea';

// Import dependencies
import { unsafeCSS, css, html, LitElement } from 'lit';
import { customElement, property } from 'lit/decorators.js';

// Import style for web component
import styles from './web-component-style.scss?inline';

// eslint-disable-next-line require-jsdoc
@customElement( 'uap-log-sidebar-property' )
export class AutomatorLogSidebarProperty extends LitElement {
	// Define style
	static styles = css`${ unsafeCSS( styles ) }`;

	// Properties
	@property( { type: String, attribute: false } ) accessor type;

	@property( { type: String, attribute: false } ) accessor label;

	@property( { type: String, attribute: false } ) accessor value;

	@property( { type: Object, attribute: false } ) accessor attributes = {};

	// eslint-disable-next-line require-jsdoc
	render() {
		if ( this.type === 'repeater' ) {
			return html`
				<uap-log-sidebar-property-repeater
					.label=${ this.label }
					.value=${ this.value }
					.attributes=${ this.attributes }
				></uap-log-sidebar-property-repeater>
			`;
		}

		if ( this.type === 'file' ) {
			return html`
				<uap-log-sidebar-property-file
					.label=${ this.label }
					.value=${ this.value }
					.attributes=${ this.attributes }
				></uap-log-sidebar-property-file>
			`;
		}

		if ( this.type === 'textarea' ) {
			return html`
				<uap-log-sidebar-property-textarea
					.label=${ this.label }
					.value=${ this.value }
					.attributes=${ this.attributes }
				></uap-log-sidebar-property-textarea>
			`;
		}

		if ( this.type === 'code' ) {
			return html`
				<uap-log-sidebar-property-code
					.label=${ this.label }
					.value=${ this.value }
					.attributes=${ this.attributes }
				></uap-log-sidebar-property-code>
			`;
		}

		return html`
			<uap-log-sidebar-property-text
				.label=${ this.label }
				.value=${ this.value }
				.attributes=${ this.attributes }
			></uap-log-sidebar-property-text>
		`;
	}
}